const VoucherRoutes = {
  getAllVouchers: '/vouchers',
  createVoucher: '/vouchers/create',
  updateVoucher: '/vouchers/update',
  deleteVoucher: '/vouchers/delete',
}

export default VoucherRoutes